import { useEffect, useState } from 'react';

const VISIBILITY_CHANGE_EVENT = 'visibility_change';
const DISABLE_INPUT_ZOOMING_EVENT = 'disable_input_zooming';

export function useSmartAssistantBubbleEventListener() {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldDisableInputZooming, setShouldDisableInputZooming] = useState(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === VISIBILITY_CHANGE_EVENT) {
        setIsVisible(event.data.isVisible);
      }

      if (event.data && event.data.type === DISABLE_INPUT_ZOOMING_EVENT) {
        setShouldDisableInputZooming(true);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return { isVisible, shouldDisableInputZooming };
}
